import { render, staticRenderFns } from "./PxAssetsTable.vue?vue&type=template&id=4713178c&scoped=true&"
import script from "./PxAssetsTable.vue?vue&type=script&lang=js&"
export * from "./PxAssetsTable.vue?vue&type=script&lang=js&"
import style0 from "./PxAssetsTable.vue?vue&type=style&index=0&id=4713178c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713178c",
  null
  
)

export default component.exports